// TODO This is simplified and slightly adjusted version of:
// '/javascript/src/legacy/flux/actions/ConversationActionCreators.js'
// with only 'createNewMatchMessage' for now.
// Because for 'createNewMatchMessage' to work properly,
// it needs to be part of the same js version as MatchesStore,
// both need to be either part of legacy or new js.
// At some point it would be good
// to move all legacy things related to conversations and messages to new js.
/* global globals */
import $ from 'jquery';
import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

const requestApi = (requestData, requestType, postData) => {
  // default type 'GET'
  const type = typeof requestType !== 'undefined' ? requestType : 'GET';

  const apiWebroot = _.get(globals, 'apiWebroot', '/');
  let url;

  let data = requestData;

  switch (data.action) {
    case 'submit':
      url = `${apiWebroot}messages/send`;
      break;
    case 'message_delete':
      url = `${apiWebroot}messages/message_delete`;
      break;
    case 'conversations_delete':
      url = `${apiWebroot}messages/conversations_delete`;
      break;
    default:
      url = `${apiWebroot}messages/get`;
      break;
  }

  // Ja POST, tad pie url piekabina data vērtības
  if (type === 'POST') {
    if (!_.isEmpty(data)) {
      // saliek korektas GET vērtības
      url += `?${$.param(data)}`;
    }
    // post dati
    if (typeof postData !== 'undefined') {
      data = postData;
    }
  }

  const post = $.ajax({
    type,
    url,
    data,
    dataType: 'json',
  });

  return post;
};

module.exports = {
  createNewMatchMessage(text, memberId, ignoreCharacterLimit = false) {
    const requestData = {
      member_id: memberId,
      action: 'submit',
      ignore_character_limit: ignoreCharacterLimit,
    };

    const request = requestApi(requestData, 'POST', { text });

    // success
    request.done((data) => {
      if (data.status === 'error') {
        AppDispatcher.dispatch({
          type: ActionTypes.MATCHES_MESSAGE_FAIL,
          message: data.message,
        });
        return;
      }

      AppDispatcher.dispatch({
        type: ActionTypes.MATCHES_MESSAGE_SUCCESS,
      });
    });

    // TODO
    // fail
    request.fail((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.MATCHES_MESSAGE_FAIL,
        message: 'Nezināma kļūda',
      });
    });
  },
};
